import Vue from 'vue'
import VueNoty from 'vuejs-noty'

Vue.use(VueNoty, {
  killer: true,
  layout: 'topCenter',
  theme: 'bootstrap-v4',
  timeout: 1500,
  progressBar: false,
  animation: {
       open: 'animated fadeInDown',
       close: 'animated fadeOutUp'
   }
})

Vue.noty.successOrError = function (success, successMsg, errorMsg, opts) {
  if (success) {
    this.success(successMsg, opts)
  } else {
    this.error(errorMsg, opts)
  }
}